module.exports = __webpack_public_path__ + "static/media/channel-web.c2bbdb98.svg";